/* Genumap storefront behaviour: motion (GSAP + Lenis when available), cart drawer, knee map, pain guide, product form. */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CFG = window.GMX || {freeShipping:4900,moneyFormat:'{{amount_with_comma_separator}} €',routes:{cart:'/cart',cartAdd:'/cart/add',cartChange:'/cart/change',root:'/'}};
  var $ = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function money(cents){
    var n=(cents/100);
    var fmt=CFG.moneyFormat||'{{amount_with_comma_separator}} €';
    var a=n.toFixed(2), withComma=a.replace('.',','), noDec=String(Math.round(n));
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
      if(k==='amount_with_comma_separator') return withComma;
      if(k==='amount_no_decimals'||k==='amount_no_decimals_with_comma_separator') return noDec;
      return a;
    }).replace(/<[^>]+>/g,'');
  }
  var hasG = function(){return !!(window.gsap && window.ScrollTrigger);};

  /* ------------------------------------------------------------ toast */
  var toastT;
  function toast(m){var t=$('[data-toast]');if(!t)return;t.textContent=m;t.hidden=false;clearTimeout(toastT);toastT=setTimeout(function(){t.hidden=true;},3200);}

  /* ------------------------------------------------------------ intro + smooth scroll */
  var lenis=null;
  function intro(done){
    var el=$('.gmx-intro');
    var seen=false;try{seen=sessionStorage.getItem('gmx-intro')==='1';}catch(e){}
    if(!el||reduce||seen||!window.gsap){if(el)el.classList.add('is-done');done();return;}
    try{sessionStorage.setItem('gmx-intro','1');}catch(e){}
    var g=window.gsap,mark=$('.gmx-intro__mark',el);
    g.timeline({onComplete:function(){el.classList.add('is-done');}})
      .fromTo(mark,{opacity:0,scale:.6,rotate:-90},{opacity:1,scale:1,rotate:0,duration:.7,ease:'expo.out'})
      .to(mark,{opacity:0,scale:1.2,duration:.35,ease:'power2.in'},'+=.15')
      .to(el,{yPercent:-100,duration:.9,ease:'expo.inOut',onStart:done},'-=.1');
  }
  function smooth(){
    if(reduce||!window.Lenis||window.matchMedia('(pointer: coarse)').matches) return;
    lenis=new window.Lenis({lerp:.1,smoothWheel:true});
    if(hasG()){
      lenis.on('scroll',window.ScrollTrigger.update);
      window.gsap.ticker.add(function(t){lenis.raf(t*1000);});
      window.gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(t){lenis.raf(t);requestAnimationFrame(raf);})(performance.now());
    }
  }
  function lockScroll(on){document.body.style.overflow=on?'hidden':'';if(lenis){on?lenis.stop():lenis.start();}}

  /* ------------------------------------------------------------ header + menu */
  function header(){
    var h=$('[data-header]');if(!h)return;
    var last=0,solidAt=40;
    function on(){
      var y=window.scrollY||0;
      h.classList.toggle('is-solid',y>solidAt);
      if(!document.body.classList.contains('is-menu-open')) h.classList.toggle('is-hidden',y>last&&y>400);
      last=y;
    }
    window.addEventListener('scroll',on,{passive:true});on();
    var btn=$('[data-menu-toggle]'),menu=$('[data-menu]');
    if(btn&&menu){
      btn.addEventListener('click',function(){
        var open=btn.getAttribute('aria-expanded')!=='true';
        btn.setAttribute('aria-expanded',String(open));
        document.body.classList.toggle('is-menu-open',open);
        h.classList.remove('is-hidden');h.classList.add('is-solid');
        if(open){
          menu.hidden=false;lockScroll(true);
          if(window.gsap&&!reduce){
            window.gsap.fromTo(menu,{clipPath:'inset(0 0 100% 0)'},{clipPath:'inset(0 0 0% 0)',duration:.7,ease:'expo.out'});
            window.gsap.fromTo($$('a',menu),{yPercent:120,opacity:0},{yPercent:0,opacity:1,stagger:.06,duration:.8,ease:'expo.out',delay:.12});
          }
        } else {
          lockScroll(false);
          if(window.gsap&&!reduce){window.gsap.to(menu,{clipPath:'inset(0 0 100% 0)',duration:.5,ease:'expo.in',onComplete:function(){menu.hidden=true;}});}
          else menu.hidden=true;
        }
      });
    }
  }

  /* ------------------------------------------------------------ motion */
  function splitWords(el){
    if(el.dataset.done) return;el.dataset.done='1';
    var words=el.textContent.trim().split(/\s+/);
    el.innerHTML=words.map(function(w){return '<span class="w">'+esc(w)+'</span>';}).join(' ');
  }
  function motion(){
    var g=window.gsap,ST=window.ScrollTrigger;
    $$('[data-words]').forEach(splitWords);
    if(!hasG()||reduce){
      $$('[data-reveal],[data-split] .gmx-line>span').forEach(function(e){e.style.opacity=1;e.style.transform='none';});
      $$('[data-words] .w').forEach(function(w){w.style.opacity=1;});
      return;
    }
    g.registerPlugin(ST);

    /* hero entrance */
    var hero=$('[data-hero]');
    if(hero){
      var tl=g.timeline({delay:.05});
      tl.to($$('[data-split] .gmx-line>span',hero),{yPercent:0,y:0,duration:1.2,stagger:.1,ease:'expo.out'})
        .to($$('[data-reveal]',hero),{opacity:1,y:0,duration:1,stagger:.08,ease:'expo.out'},'-=.9');
      $$('[data-split]',hero).forEach(function(e){e.dataset.played='1';});
      hero.addEventListener('pointermove',function(e){
        var r=hero.getBoundingClientRect();
        hero.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
        hero.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
      });
    }

    /* split headings */
    $$('[data-split]').forEach(function(el){
      if(el.dataset.played) return;
      g.to($$('.gmx-line>span',el),{yPercent:0,y:0,duration:1.1,stagger:.09,ease:'expo.out',scrollTrigger:{trigger:el,start:'top 88%'}});
    });
    /* generic reveals */
    $$('[data-reveal]').forEach(function(el){
      if(el.closest('[data-hero]')) return;
      g.to(el,{opacity:1,y:0,duration:1,ease:'expo.out',scrollTrigger:{trigger:el,start:'top 90%'}});
    });
    /* index rules */
    $$('.gmx-index').forEach(function(el){
      g.fromTo(el,{'--rule':0},{'--rule':1,duration:1.4,ease:'expo.out',scrollTrigger:{trigger:el,start:'top 92%'}});
    });
    /* manifesto: words light up with scroll */
    $$('[data-words]').forEach(function(el){
      g.to($$('.w',el),{opacity:1,stagger:.08,ease:'none',scrollTrigger:{trigger:el,start:'top 80%',end:'bottom 45%',scrub:.6}});
    });
    /* strike-through draws in */
    $$('[data-strike]').forEach(function(el){
      var b=$('.gmx-problem__before',el);if(!b)return;
      g.fromTo(b,{'--strike':0},{'--strike':1,duration:.9,ease:'expo.inOut',delay:.35,scrollTrigger:{trigger:el,start:'top 82%'}});
    });
    /* counters */
    $$('[data-count]').forEach(function(el){
      var to=parseFloat(el.getAttribute('data-count'));if(isNaN(to))return;
      var o={v:0};
      g.to(o,{v:to,duration:1.6,ease:'expo.out',scrollTrigger:{trigger:el,start:'top 90%'},onUpdate:function(){el.textContent=Math.round(o.v);},onComplete:function(){el.textContent=to;}});
    });
    /* big marquee rows driven by scroll */
    $$('[data-bigmarquee]').forEach(function(row){
      var dir=parseFloat(row.getAttribute('data-bigmarquee'))||1;
      g.fromTo(row,{xPercent:dir>0?0:-33.333},{xPercent:dir>0?-33.333:0,ease:'none',scrollTrigger:{trigger:row.parentNode,start:'top bottom',end:'bottom top',scrub:.4}});
    });
    /* range: horizontal pin on desktop */
    var range=$('[data-range]');
    if(range){
      var mm=g.matchMedia();
      mm.add('(min-width: 901px)',function(){
        var track=$('[data-range-track]',range),bar=$('[data-range-bar]',range);
        var dist=function(){return Math.max(0,track.scrollWidth-window.innerWidth);};
        g.to(track,{x:function(){return -dist();},ease:'none',scrollTrigger:{trigger:range,start:'top top',end:function(){return '+='+dist();},pin:true,scrub:.6,invalidateOnRefresh:true,onUpdate:function(s){if(bar)bar.style.setProperty('--p',s.progress);}}});
      });
      mm.add('(max-width: 900px)',function(){
        var track=$('[data-range-track]',range),bar=$('[data-range-bar]',range);
        var f=function(){var m=track.scrollWidth-track.clientWidth;bar&&bar.style.setProperty('--p',m>0?track.scrollLeft/m:0);};
        track.addEventListener('scroll',f,{passive:true});f();
      });
    }
    /* steps: active state + big counter */
    var steps=$('[data-steps]');
    if(steps){
      var count=$('[data-step-count]',steps);
      $$('.gmx-step',steps).forEach(function(st){
        ST.create({trigger:st,start:'top 60%',end:'bottom 60%',onToggle:function(s){
          if(!s.isActive) return;
          $$('.gmx-step',steps).forEach(function(x){x.classList.toggle('is-active',x===st);});
          if(count){g.fromTo(count,{yPercent:100},{yPercent:0,duration:.6,ease:'expo.out'});count.textContent=st.getAttribute('data-step');}
        }});
      });
    }
    /* parallax image band */
    $$('[data-parallax]').forEach(function(el){
      g.fromTo(el,{yPercent:-8},{yPercent:8,ease:'none',scrollTrigger:{trigger:el.parentNode,start:'top bottom',end:'bottom top',scrub:true}});
    });
    /* guarantee seal spins with scroll */
    $$('[data-spin]').forEach(function(el){
      g.to(el,{rotate:360,ease:'none',scrollTrigger:{trigger:el,start:'top bottom',end:'bottom top',scrub:1}});
    });
    /* CTA rings breathe */
    $$('[data-cta] .gmx-cta__ring').forEach(function(r,i){
      g.fromTo(r,{scale:.8,opacity:0},{scale:1,opacity:1,ease:'none',scrollTrigger:{trigger:r.parentNode,start:'top 85%',end:'center center',scrub:true}});
    });
    /* footer wordmark rises */
    var fw=$('.gmx-footer__word span');
    if(fw) g.fromTo(fw,{yPercent:60},{yPercent:0,ease:'none',scrollTrigger:{trigger:'.gmx-footer',start:'top bottom',end:'bottom bottom',scrub:true}});

    window.addEventListener('load',function(){ST.refresh();});
  }

  /* ------------------------------------------------------------ magnetic buttons */
  function magnetic(){
    if(reduce||window.matchMedia('(pointer: coarse)').matches) return;
    $$('[data-magnetic]').forEach(function(b){
      b.addEventListener('pointermove',function(e){
        var r=b.getBoundingClientRect(),x=(e.clientX-r.left-r.width/2)*.25,y=(e.clientY-r.top-r.height/2)*.35;
        b.style.transform='translate('+x+'px,'+y+'px)';
      });
      b.addEventListener('pointerleave',function(){b.style.transition='transform .6s cubic-bezier(.16,1,.3,1),color .45s,border-color .45s';b.style.transform='';setTimeout(function(){b.style.transition='';},600);});
    });
  }

  /* ------------------------------------------------------------ accordions */
  function accordions(root){
    $$('[data-acc]',root).forEach(function(acc){
      if(acc.dataset.ready) return;acc.dataset.ready='1';
      var btn=$('button',acc),panel=$('.gmx-acc__panel',acc);
      btn.addEventListener('click',function(){
        var open=!acc.classList.contains('is-open');
        acc.classList.toggle('is-open',open);btn.setAttribute('aria-expanded',String(open));
        var h=panel.scrollHeight;
        if(open){panel.style.height='0px';requestAnimationFrame(function(){panel.style.height=h+'px';});setTimeout(function(){if(acc.classList.contains('is-open'))panel.style.height='auto';},560);}
        else{panel.style.height=h+'px';requestAnimationFrame(function(){panel.style.height='0px';});}
        if(window.ScrollTrigger) setTimeout(function(){window.ScrollTrigger.refresh();},600);
      });
    });
  }

  /* ------------------------------------------------------------ cart */
  var cartState=null;
  function cartFetch(){return fetch((CFG.routes.cart||'/cart')+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();});}
  function renderCart(cart){
    cartState=cart;
    $$('[data-cart-count]').forEach(function(c){
      if(c.textContent!==String(cart.item_count)){c.classList.remove('is-bump');void c.offsetWidth;c.classList.add('is-bump');}
      c.textContent=cart.item_count;
    });
    var ship=$('[data-cart-ship]'),lines=$('[data-cart-lines]'),foot=$('[data-cart-foot]');
    if(!lines) return;
    var left=Math.max(0,CFG.freeShipping-cart.total_price);
    ship.innerHTML='<span>'+(left>0?'Plus que <b>'+money(left)+'</b> pour la livraison offerte':'<b>Livraison offerte</b> sur votre commande')+'</span><div class="gmx-ship__bar"><i style="width:'+Math.min(100,cart.total_price/CFG.freeShipping*100)+'%"></i></div>';
    if(!cart.items.length){
      lines.innerHTML='<div class="gmx-empty"><p>Votre panier est vide. Le guide trouve votre soutien en 60 secondes.</p><a class="gmx-btn" href="/pages/guide"><span>Faire le guide</span><i aria-hidden="true">→</i></a></div>';
      foot.innerHTML='';return;
    }
    lines.innerHTML=cart.items.map(function(it,i){
      var opts=(it.options_with_values||[]).filter(function(o){return o.name!=='Title';}).map(function(o){return esc(o.value);}).join(' · ');
      return '<div class="gmx-line-item" data-line="'+(i+1)+'">'+
        '<a class="gmx-line-item__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(it.image)+'&width=200" alt="" loading="lazy">':'<span class="gmx-ph"></span>')+'</a>'+
        '<div><a class="gmx-line-item__title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a><small>'+opts+'</small>'+
        '<div class="gmx-qty"><button type="button" data-qty="-1" aria-label="Retirer un">−</button><span>'+it.quantity+'</span><button type="button" data-qty="1" aria-label="Ajouter un">+</button></div></div>'+
        '<div class="gmx-line-item__price">'+(CFG.gift&&it.handle===CFG.gift.handle&&it.final_line_price===0?'<b class="gmx-gift">Offert</b>':money(it.final_line_price))+(it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'')+'</div></div>';
    }).join('');
    var bumpHtml='';
    if(CFG.bump&&!cart.items.some(function(it){return it.handle===CFG.bump.handle;})){
      var unlock=left>0&&cart.total_price+CFG.bump.price>=CFG.freeShipping;
      bumpHtml='<div class="gmx-bump">'+(CFG.bump.image?'<img src="'+esc(CFG.bump.image)+'" alt="" loading="lazy">':'<span class="gmx-bump__ico" aria-hidden="true">❄</span>')+
        '<div><b>'+esc(CFG.bump.title)+'</b><small>'+(unlock?'Ajoutez-la : <b>livraison offerte</b>':'Froid après l’effort, chaud le matin')+'</small></div>'+
        '<button type="button" class="gmx-bump__add" data-bump-add>+ '+money(CFG.bump.price)+'</button></div>';
    }
    foot.innerHTML=bumpHtml+'<div class="gmx-drawer__total"><span>Total</span><span>'+money(cart.total_price)+'</span></div>'+
      '<a class="gmx-btn gmx-btn--block" href="/checkout"><span>Passer commande</span><i aria-hidden="true">→</i></a>'+
      '<p class="gmx-drawer__note">Paiement sécurisé · 60 jours pour changer d’avis</p>';
    if(window.gsap&&!reduce) window.gsap.from($$('.gmx-line-item',lines),{opacity:0,y:16,stagger:.05,duration:.5,ease:'expo.out'});
  }
  function cartChange(line,qty){
    return fetch((CFG.routes.cartChange||'/cart/change')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
  }
  function openCart(){
    var d=$('[data-cart-drawer]'),s=$('.gmx-scrim');if(!d)return;
    d.hidden=false;s.hidden=false;lockScroll(true);
    if(window.gsap&&!reduce){window.gsap.fromTo(d,{xPercent:100},{xPercent:0,duration:.7,ease:'expo.out'});window.gsap.fromTo(s,{opacity:0},{opacity:1,duration:.4});}
    var c=$('[data-cart-close].gmx-icon-btn',d);c&&c.focus();
  }
  function closeCart(){
    var d=$('[data-cart-drawer]'),s=$('.gmx-scrim');if(!d||d.hidden)return;
    lockScroll(false);
    if(window.gsap&&!reduce){window.gsap.to(d,{xPercent:100,duration:.5,ease:'expo.in',onComplete:function(){d.hidden=true;}});window.gsap.to(s,{opacity:0,duration:.4,onComplete:function(){s.hidden=true;}});}
    else{d.hidden=true;s.hidden=true;}
  }
  function cart(){
    $$('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(){cartFetch().then(renderCart);openCart();});});
    $$('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
    var lines=$('[data-cart-lines]');
    if(lines) lines.addEventListener('click',function(e){
      var b=e.target.closest('[data-qty]');if(!b)return;
      var row=b.closest('[data-line]'),i=parseInt(row.getAttribute('data-line'),10),it=cartState.items[i-1];
      row.style.opacity=.5;cartChange(i,Math.max(0,it.quantity+parseInt(b.getAttribute('data-qty'),10)));
    });
    var foot=$('[data-cart-foot]');
    if(foot) foot.addEventListener('click',function(e){
      var b=e.target.closest('[data-bump-add]');if(!b||!CFG.bump)return;
      b.disabled=true;addToCart(CFG.bump.id,1).catch(function(err){b.disabled=false;toast(err.message||'Impossible d’ajouter ce produit.');});
    });
    cartFetch().then(renderCart).catch(function(){});
  }
  function addToCart(id,qty,extra){
    var items=[{id:id,quantity:qty||1}].concat(extra||[]);
    return fetch((CFG.routes.cartAdd||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Erreur');});return r.json();})
      .then(cartFetch).then(function(c){renderCart(c);openCart();});
  }

  /* ------------------------------------------------------------ zones */
  var ZONES={
    quad:{label:'Au-dessus de la rotule',cause:'Peut venir du tendon quadricipital, très sollicité par les sauts, les squats et les escaliers.',prod:'g02'},
    rotule:{label:'Sur ou autour de la rotule',cause:'Typique d’une rotule qui frotte : douleur en descendant les escaliers ou après être resté longtemps assis.',prod:'g02'},
    tendon:{label:'Juste sous la rotule',cause:'Souvent le tendon rotulien, le « genou du sauteur » : course, foot, padel, descentes en randonnée.',prod:'g01'},
    interne:{label:'Côté intérieur',cause:'Peut concerner le ligament interne ou le ménisque, surtout après une torsion ou un changement de direction.',prod:'g03'},
    externe:{label:'Côté extérieur',cause:'Souvent la bandelette ilio-tibiale chez les coureurs et cyclistes, qui frotte sur le côté du genou.',prod:'g05'},
    arriere:{label:'Derrière le genou',cause:'Souvent une tension des ischio-jambiers. Si ça gonfle derrière le genou, faites-le vérifier.',prod:'g04'},
    partout:{label:'Partout, raideur, gonflement',cause:'Une douleur diffuse avec raideur le matin appelle plutôt une compression douce et chaude sur tout le genou.',prod:'g04'}
  };
  var P=function(){return window.GMX_PRODUCTS||{};};
  function fallbackFor(zid){return (zid==='externe'||zid==='interne')?'g04':'g01';}

  /* ------------------------------------------------------------ knee map */
  function kneeMap(root){
    var stage=$('[data-stage]',root);if(!stage)return;
    var hs=$('[data-hotspots]',stage),chips=$('[data-chips]',stage);
    var guideUrl=root.getAttribute('data-guide-url')||'/pages/guide';
    var SPOTS=[{id:'quad',p:[0,0.8,0.44],t:'Dessus'},{id:'rotule',p:[0,0.16,0.64],t:'Rotule'},{id:'tendon',p:[0,-0.44,0.52],t:'Dessous'},{id:'interne',p:[-0.62,0.02,0.2],t:'Intérieur'},{id:'externe',p:[0.62,0.02,0.2],t:'Extérieur'}];
    var els={};
    // Photo mode: hotspots sit on the numbered circles drawn on the uploaded photo (% of the full image).
    if(stage.classList.contains('gmx-stage--photo')){
      [['tendon',51.6,54.8,'1'],['rotule',51.3,43,'2'],['quad',52.5,29.1,'3'],['interne',67,44.4,'4'],['externe',36.2,44.2,'5'],['arriere',77.9,39.1,'6'],['partout',52.5,62.1,'7']].forEach(function(s){
        var b=document.createElement('button');b.type='button';b.className='gmx-hot';b.setAttribute('aria-label',s[3]+'. '+ZONES[s[0]].label);
        b.style.left=s[1]+'%';b.style.top=s[2]+'%';
        b.innerHTML='<span class="gmx-hot__label">'+ZONES[s[0]].label+'</span>';
        b.addEventListener('click',function(){pick(s[0],true);});hs.appendChild(b);els[s[0]]=b;
      });
    }
    else SPOTS.forEach(function(s){
      var b=document.createElement('button');b.type='button';b.className='gmx-hot';b.setAttribute('aria-label',ZONES[s.id].label);
      b.innerHTML='<i></i><span class="gmx-hot__label">'+s.t+'</span>';
      b.addEventListener('click',function(){pick(s.id,true);});hs.appendChild(b);els[s.id]=b;
    });
    var card=$('.gmx-zone',stage);
    function pick(id,anim){
      Object.keys(els).forEach(function(k){els[k].setAttribute('aria-pressed',String(k===id));});
      var z=ZONES[id],p=P()[z.prod]||{full:'',price:'',code:''};
      var apply=function(){
        $('[data-zlabel]',stage).textContent=z.label;
        $('[data-zcause]',stage).textContent=z.cause;
        $('[data-zcode]',stage).textContent=p.code||'';
        $('[data-zprod]',stage).textContent=p.full+' · '+p.price+(p.available?'':' · bientôt');
        var cta=$('[data-zcta]',stage);
        if(p.available){cta.href=p.url;$('span',cta).textContent='Voir '+p.code;}
        else{cta.href=guideUrl+'?zone='+id;$('span',cta).textContent='Affiner en 4 questions';}
      };
      if(anim&&window.gsap&&!reduce){window.gsap.timeline().to(card,{y:10,opacity:0,duration:.18,ease:'power2.in',onComplete:apply}).to(card,{y:0,opacity:1,duration:.5,ease:'expo.out'});}
      else apply();
      if(three) three.focus(id);
    }

    function initThree(){
      if(!window.THREE) return false;
      var canvas=document.createElement('canvas'),gl=null;
      try{gl=canvas.getContext('webgl',{antialias:true,alpha:true})||canvas.getContext('experimental-webgl');}catch(e){}
      if(!gl) return false;
      var T=window.THREE;
      var renderer=new T.WebGLRenderer({canvas:canvas,context:gl,antialias:true,alpha:true});
      renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
      stage.insertBefore(canvas,stage.firstChild);
      var scene=new T.Scene();
      var camera=new T.PerspectiveCamera(30,1,0.1,100);camera.position.set(0,0.25,6.4);
      var leg=new T.Group();scene.add(leg);
      var skin=new T.MeshStandardMaterial({color:0xEDEDEA,roughness:.5,metalness:.05});
      var bone=new T.MeshStandardMaterial({color:0xFFFFFF,roughness:.3,metalness:.1,emissive:0x111111});
      var wire=new T.MeshBasicMaterial({color:0xFFFFFF,wireframe:true,transparent:true,opacity:.05});
      function limb(rt,rb,len,y){var g=new T.Group();g.add(new T.Mesh(new T.CylinderGeometry(rt,rb,len,72,1,true),skin));g.add(new T.Mesh(new T.CylinderGeometry(rt*1.005,rb*1.005,len,28,10,true),wire));g.position.y=y;return g;}
      leg.add(limb(.8,.6,2.3,1.35));leg.add(limb(.58,.42,2.5,-1.45));
      var joint=new T.Mesh(new T.SphereGeometry(.64,72,54),skin);joint.scale.set(1,.9,.9);leg.add(joint);
      var patella=new T.Mesh(new T.SphereGeometry(.3,48,32),bone);patella.scale.set(1,1.15,.45);patella.position.set(0,.16,.54);leg.add(patella);
      var tendon=new T.Mesh(new T.CylinderGeometry(.09,.11,.62,24),bone);tendon.position.set(0,-.37,.5);tendon.rotation.x=.18;leg.add(tendon);
      var strapMat=new T.MeshStandardMaterial({color:0x101010,roughness:.55});
      var strap=new T.Mesh(new T.TorusGeometry(.58,.055,16,120),strapMat);strap.rotation.x=Math.PI/2;strap.position.y=-.5;strap.scale.set(1,.92,1);leg.add(strap);
      var pulse=new T.Mesh(new T.RingGeometry(.12,.15,48),new T.MeshBasicMaterial({color:0xffffff,transparent:true,opacity:.9,side:T.DoubleSide}));leg.add(pulse);
      scene.add(new T.AmbientLight(0xffffff,.42));
      var key=new T.DirectionalLight(0xffffff,.95);key.position.set(3,4,5);scene.add(key);
      var rim=new T.DirectionalLight(0xffffff,.7);rim.position.set(-4,1.5,-3);scene.add(rim);
      var anchors=SPOTS.map(function(s){var o=new T.Object3D();o.position.set(s.p[0],s.p[1],s.p[2]);leg.add(o);return o;});
      var FOCUS={quad:0,rotule:0,tendon:0,interne:.75,externe:-.75,arriere:Math.PI,partout:0};
      var rotY=-.3,target=-.3,drag=false,lastX=0,auto=!reduce,t0=performance.now(),v=new T.Vector3(),visible=true,focusId='tendon';
      canvas.style.touchAction='pan-y';
      canvas.addEventListener('pointerdown',function(e){drag=true;lastX=e.clientX;auto=false;var h=$('[data-hint]',stage);if(h)h.style.opacity=0;});
      window.addEventListener('pointerup',function(){drag=false;});
      window.addEventListener('pointermove',function(e){if(!drag)return;target+=(e.clientX-lastX)*.008;target=Math.max(-1.2,Math.min(1.2,target));lastX=e.clientX;});
      if('IntersectionObserver' in window) new IntersectionObserver(function(es){visible=es[0].isIntersecting;if(visible)requestAnimationFrame(frame);}).observe(stage);
      function frame(now){
        if(auto) target=FOCUS[focusId]+Math.sin((now-t0)/2600)*.35;
        rotY+=(target-rotY)*.06;
        leg.rotation.y=rotY;leg.rotation.x=.05;
        var sp=SPOTS.filter(function(s){return s.id===focusId;})[0];
        if(sp){pulse.position.set(sp.p[0]*1.02,sp.p[1],sp.p[2]*1.02);pulse.lookAt(sp.p[0]*3,sp.p[1],sp.p[2]*3);var k=1+((now/900)%1)*1.6;pulse.scale.set(k,k,k);pulse.material.opacity=.9*(1-((now/900)%1));pulse.visible=true;}
        else pulse.visible=false;
        renderer.render(scene,camera);
        var w=canvas.clientWidth,h=canvas.clientHeight;
        SPOTS.forEach(function(s,i){
          anchors[i].getWorldPosition(v);
          var facing=Math.cos(rotY)*s.p[2]-Math.sin(rotY)*s.p[0];
          v.project(camera);
          var el=els[s.id];el.style.left=((v.x+1)/2*w)+'px';el.style.top=((1-v.y)/2*h)+'px';
          el.style.opacity=facing<-.05?'.12':'1';el.style.pointerEvents=facing<-.05?'none':'auto';
        });
        if(visible&&!document.hidden) requestAnimationFrame(frame);
      }
      function size(){var w=stage.clientWidth,h=stage.clientHeight;if(!w||!h)return;renderer.setSize(w,h,false);camera.aspect=w/h;camera.fov=w/h<.95?35:30;camera.updateProjectionMatrix();}
      size();window.addEventListener('resize',size);
      document.addEventListener('visibilitychange',function(){if(!document.hidden&&visible)requestAnimationFrame(frame);});
      requestAnimationFrame(frame);
      return {focus:function(id){focusId=id;if(!auto)target=FOCUS[id]||0;}};
    }
    function fallback(){
      var h=$('[data-hint]',stage);if(h)h.textContent='Touchez une zone';
      var f=document.createElement('div');f.setAttribute('aria-hidden','true');f.style.cssText='position:absolute;inset:0;display:flex;align-items:center;justify-content:center';
      f.innerHTML='<svg viewBox="0 0 360 440" width="70%" height="80%"><path d="M105 0 C100 90 112 150 120 200 C126 236 122 262 118 290 C112 340 120 390 128 440 L232 440 C240 390 248 340 242 290 C238 262 234 236 240 200 C248 150 260 90 255 0 Z" fill="none" stroke="#fff" stroke-opacity=".35" stroke-width="1.5"/><ellipse cx="180" cy="226" rx="40" ry="48" fill="none" stroke="#fff" stroke-width="1.5"/></svg>';
      stage.insertBefore(f,stage.firstChild);
      var pos={quad:[50,30],rotule:[50,46],tendon:[50,58],interne:[33,50],externe:[67,50]};
      Object.keys(pos).forEach(function(k){els[k].style.left=pos[k][0]+'%';els[k].style.top=pos[k][1]+'%';});
    }
    var three=null;
    if(!stage.classList.contains('gmx-stage--photo')){
      [['arriere','Derrière le genou'],['partout','Partout / je ne sais pas']].forEach(function(c){
        var b=document.createElement('button');b.type='button';b.className='gmx-chip';b.textContent=c[1];
        b.addEventListener('click',function(){pick(c[0],true);});chips.appendChild(b);els[c[0]]=b;
      });
      three=initThree();if(!three) fallback();
    }
    pick('tendon',false);
  }

  /* ------------------------------------------------------------ pain guide */
  var Q=[
    {key:'zone',title:'Où avez-vous mal ?',help:'Posez un doigt sur la douleur et choisissez l’endroit le plus précis.',opts:[['tendon','Juste sous la rotule'],['rotule','Sur ou autour de la rotule'],['quad','Au-dessus de la rotule'],['interne','Côté intérieur'],['externe','Côté extérieur'],['arriere','Derrière le genou'],['partout','Partout / je ne sais pas']]},
    {key:'moment',title:'Quand est-ce que ça fait le plus mal ?',help:'Le moment de la douleur aide à confirmer la zone.',opts:[['escaliers','Escaliers ou descentes'],['sport','Pendant ou après le sport'],['assis','Après être resté assis'],['genoux','À genoux (travail, jardin, prière)'],['matin','Le matin, genou raide']]},
    {key:'flag',title:'Avez-vous un de ces signes ?',help:'On vous pose la question pour votre sécurité.',opts:[['non','Non, aucun'],['gonfle','Gonflement soudain'],['bloque','Le genou se bloque ou lâche'],['choc','Douleur après un choc ou une chute']]},
    {key:'goal',title:'Qu’aimeriez-vous refaire sans y penser ?',help:'On adapte votre routine à cet objectif.',opts:[['sport','Reprendre mon sport'],['marche','Marcher, randonner'],['travail','Tenir ma journée de travail'],['quotidien','Les escaliers, le quotidien']]}
  ];
  var GOALS={sport:'reprendre le sport',marche:'marcher et randonner',travail:'tenir vos journées de travail',quotidien:'monter les escaliers sans y penser'};
  function guide(box){
    var G={step:0,a:{}};
    var pre=(location.search.match(/[?&]zone=([a-z]+)/)||[])[1];
    if(pre&&ZONES[pre]){G.a.zone=pre;G.step=1;}
    function media(p){return '<div class="gmx-result__media">'+(p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.full)+'">':'<div class="gmx-ph"><span class="gmx-ph__label">Photo '+esc(p.code)+'</span></div>')+'<span class="gmx-card__code" aria-hidden="true">'+esc((p.code||'').replace('G·',''))+'</span></div>';}
    function html(){
      var total=Q.length,done=Math.min(G.step,total);
      var h='<div style="display:grid;gap:12px"><div class="gmx-guide__top gmx-eyebrow"><span>'+(G.step<total?'Question '+(G.step+1)+' sur '+total:'Votre résultat')+'</span><span>Guide de la douleur</span></div><div class="gmx-progress"><i style="--p:'+(G.step<total?done/total:1)+'"></i></div></div>';
      if(G.step<total){
        var q=Q[G.step];
        h+='<h1 class="gmx-q" data-anim><span class="gmx-line"><span>'+q.title+'</span></span></h1><p class="gmx-q-help" data-anim>'+q.help+'</p><div class="gmx-choices">';
        q.opts.forEach(function(o,i){h+='<button type="button" class="gmx-choice" data-anim data-k="'+q.key+'" data-v="'+o[0]+'"><span>'+o[1]+'</span><kbd>'+String.fromCharCode(65+i)+'</kbd></button>';});
        h+='</div><div class="gmx-guide__nav">'+(G.step>0?'<button type="button" class="gmx-textbtn gmx-link" data-back>← Question précédente</button>':'<span></span>')+'<span class="gmx-eyebrow gmx-mute">Ne remplace pas un avis médical</span></div>';
      } else {
        var zid=G.a.zone||'partout';if(zid==='partout'&&G.a.moment==='escaliers')zid='rotule';
        var p=P()[ZONES[zid].prod]||{},alt=p.available?p:(P()[fallbackFor(zid)]||{}),flag=G.a.flag&&G.a.flag!=='non';
        h+='<div class="gmx-result"><div data-anim>'+media(p)+'</div><div style="display:grid;gap:20px">'+
          '<span class="gmx-eyebrow gmx-mute" data-anim>Zone · '+ZONES[zid].label+'</span>'+
          '<h1 class="gmx-q" data-anim><span class="gmx-line"><span>'+esc(p.full)+'</span></span></h1>'+
          (flag?'<div class="gmx-alert" data-anim>Vous avez coché un signe qui mérite un avis médical. Consultez d’abord un médecin ou un kiné, puis utilisez ce soutien si on vous le conseille.</div>':'')+
          '<p class="gmx-q-help" data-anim>'+ZONES[zid].cause+'</p>'+
          '<ul class="gmx-ticks" data-anim><li>Routine de 5 minutes pour '+(GOALS[G.a.goal]||'votre objectif')+'</li><li>Remboursé si elle glisse, 60 jours</li><li>Échange de taille offert</li></ul>'+
          (p.available?'<div data-anim><a class="gmx-btn" href="'+esc(p.url)+'"><span>Choisir ma taille · '+esc(p.price)+'</span><i aria-hidden="true">→</i></a></div>':
            '<div class="gmx-alert" data-anim>'+esc(p.full)+' arrive bientôt. En attendant, '+esc(alt.full)+' peut vous soulager au quotidien.</div>'+(alt.url?'<div data-anim><a class="gmx-btn" href="'+esc(alt.url)+'"><span>Voir '+esc(alt.full)+'</span><i aria-hidden="true">→</i></a></div>':''))+
          '<button type="button" class="gmx-textbtn gmx-link" data-restart data-anim style="justify-self:start">Recommencer le guide</button></div></div>';
      }
      return h;
    }
    function bind(){
      $$('.gmx-choice',box).forEach(function(b){b.addEventListener('click',function(){G.a[b.getAttribute('data-k')]=b.getAttribute('data-v');go(1);});});
      var bk=$('[data-back]',box);bk&&bk.addEventListener('click',function(){go(-1);});
      var rs=$('[data-restart]',box);rs&&rs.addEventListener('click',function(){G={step:0,a:{}};go(0);});
    }
    function enter(){
      if(!window.gsap||reduce) return;
      window.gsap.fromTo($$('.gmx-line>span',box),{yPercent:105},{yPercent:0,duration:.9,ease:'expo.out'});
      window.gsap.fromTo($$('[data-anim]:not(h1):not(h2)',box),{opacity:0,y:24},{opacity:1,y:0,duration:.7,stagger:.05,ease:'expo.out',delay:.1});
    }
    var embed=!!box.closest('.gmx-guide--embed');
    function render(){var h=html();if(embed)h=h.replace(/<h1 /g,'<h2 ').replace(/<\/h1>/g,'</h2>');box.innerHTML=h;bind();enter();}
    function go(d){
      var next=function(){G.step=Math.max(0,G.step+d);if(d===0)G.step=0;render();var top=box.getBoundingClientRect().top+window.scrollY-120;if(window.scrollY>top)window.scrollTo({top:top,behavior:reduce?'auto':'smooth'});};
      if(window.gsap&&!reduce) window.gsap.to($$('[data-anim]',box),{opacity:0,y:-16,duration:.25,stagger:.02,ease:'power2.in',onComplete:next});
      else next();
    }
    document.addEventListener('keydown',function(e){
      if(G.step>=Q.length||/input|textarea|select/i.test((e.target.tagName||''))) return;
      var r=box.getBoundingClientRect();if(r.bottom<80||r.top>window.innerHeight-80) return;
      var i=e.key.toUpperCase().charCodeAt(0)-65,btns=$$('.gmx-choice',box);
      if(e.key.length===1&&i>=0&&i<btns.length) btns[i].click();
    });
    render();
  }

  /* ------------------------------------------------------------ product form */

  function promo(){
    $$('[data-promo]').forEach(function(el){
      var end=el.getAttribute('data-end'),t=$('[data-promo-timer]',el);if(!end||!t)return;
      var e=new Date(end).getTime();if(isNaN(e)){t.remove();return;}
      function tick(){var d=Math.max(0,e-Date.now());if(!d){el.remove();clearInterval(iv);return;}
        var v={d:Math.floor(d/864e5),h:Math.floor(d/36e5)%24,m:Math.floor(d/6e4)%60,s:Math.floor(d/1e3)%60};
        $$('[data-t]',t).forEach(function(i){var n=v[i.getAttribute('data-t')];i.textContent=(n<10?'0':'')+n;});}
      var iv=setInterval(tick,1000);tick();
    });
  }
  function eta(){
    $$('[data-eta]').forEach(function(el){
      function add(n){var d=new Date();while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w&&w!==6)n--;}return d;}
      var f=function(d){return d.toLocaleDateString('fr-FR',{weekday:'short',day:'numeric',month:'short'});};
      var a=$('[data-eta-a]',el),b=$('[data-eta-b]',el);
      a.textContent=f(add(+el.getAttribute('data-min')||3));b.textContent=f(add(+el.getAttribute('data-max')||6));
    });
  }

  function wrapAnim(){
    $$('[data-wa]').forEach(function(el){
      var steps=$$('.gmx-wa__steps li',el),t0=0,raf=0;
      function loop(now){if(!t0)t0=now;var p=((now-t0)%6000)/6000,i=p<.2?0:p<.5?1:2;steps.forEach(function(li,k){li.classList.toggle('is-on',k===i);});raf=requestAnimationFrame(loop);}
      if(!('IntersectionObserver' in window)){el.classList.add('is-on');raf=requestAnimationFrame(loop);return;}
      new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){if(!el.classList.contains('is-on')){el.classList.add('is-on');t0=0;$$('.wa-zone,.wa-back,.wa-front,.wa-sleeve,.wa-detail,.wa-press',el).forEach(function(n){n.style.animation='none';n.getBoundingClientRect();n.style.animation='';});raf=requestAnimationFrame(loop);}}
        else{el.classList.remove('is-on');cancelAnimationFrame(raf);}
      });},{threshold:.35}).observe(el);
    });
  }
  function pdp(root){
    var jsonEl=$('[data-product-json]');if(!jsonEl)return;
    var product;try{product=JSON.parse(jsonEl.textContent);}catch(e){return;}
    var form=$('[data-product-form]',root),select=$('[data-variant-select]',root),atc=$('[data-atc]',root),label=$('[data-atc-label]',root);
    var priceEl=$('[data-price]',root),cmpEl=$('[data-compare]',root),saveEl=$('[data-save]',root);
    var sticky=$('[data-sticky-buy]'),stickyPrice=$('[data-sticky-price]'),stickyBtn=$('[data-sticky-atc]');
    function selected(){var opts=[];product.options.forEach(function(_,i){var c=$('input[data-option="'+i+'"]:checked',root);opts.push(c?c.value:null);});return opts;}
    function find(opts){return product.variants.filter(function(v){return v.options.every(function(o,i){return opts[i]==null||o===opts[i];});})[0];}
    function update(){
      var opts=selected(),v=find(opts);
      product.options.forEach(function(_,i){var l=$('[data-opt-label="'+i+'"]',root);if(l)l.textContent=opts[i]||'';});
      /* grey out impossible combinations for the last options */
      product.options.forEach(function(_,i){
        $$('input[data-option="'+i+'"]',root).forEach(function(inp){
          var test=opts.slice();test[i]=inp.value;var m=find(test);inp.disabled=!m||!m.available;
        });
      });
      if(!v){atc.disabled=true;label.textContent='Indisponible';return;}
      select.value=v.id;
      var animate=priceEl.textContent!==money(v.price);
      priceEl.textContent=money(v.price);
      if(animate&&window.gsap&&!reduce) window.gsap.fromTo(priceEl,{yPercent:40,opacity:0},{yPercent:0,opacity:1,duration:.5,ease:'expo.out'});
      var hasCmp=v.compare_at_price&&v.compare_at_price>v.price;
      cmpEl.hidden=!hasCmp;saveEl.hidden=!hasCmp;
      if(hasCmp){cmpEl.textContent=money(v.compare_at_price);saveEl.textContent='Économisez '+money(v.compare_at_price-v.price);}
      atc.disabled=!v.available;
      label.textContent=v.available?'Ajouter au panier · '+money(v.price):'Épuisé';
      if(stickyPrice) stickyPrice.textContent=money(v.price);
      var st=$('[data-stock]',root);if(st){try{var mp=JSON.parse(st.getAttribute('data-map')),n=mp[v.id],lo=+st.getAttribute('data-low')||10;st.hidden=!(n>0&&n<=lo);if(n>0){$('[data-stock-n]',st).textContent=n;$('[data-stock-bar]',st).style.width=Math.min(100,n*100/lo)+'%';}}catch(e){}}
      try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());}catch(e){}
    }
    root.addEventListener('change',function(e){if(e.target.matches('[data-option]'))update();});
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(atc.disabled) return;
      atc.classList.add('is-loading');atc.disabled=true;
      var oi=$('input[data-offer-i]:checked',root),extra=[];
      if(CFG.gift&&oi&&+oi.getAttribute('data-offer-i')>1&&!(cartState&&cartState.items.some(function(it){return it.handle===CFG.gift.handle;})))extra.push({id:CFG.gift.id,quantity:1});
      addToCart(parseInt(select.value,10),1,extra).catch(function(err){toast(err.message||'Impossible d’ajouter ce produit.');}).then(function(){atc.classList.remove('is-loading');atc.disabled=false;});
    });
    if(stickyBtn) stickyBtn.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit(atc);else atc.click();});
    if(sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){var off=!es[0].isIntersecting&&es[0].boundingClientRect.top<0;sticky.classList.toggle('is-on',off);sticky.setAttribute('aria-hidden',String(!off));if(stickyBtn)stickyBtn.tabIndex=off?0:-1;}).observe(atc);
    }
    /* mobile gallery dots */
    var gal=$('[data-gallery]',root),dots=$('[data-gallery-dots]',root);
    if(gal&&dots){
      var items=$$('.gmx-gallery__item',gal);dots.innerHTML=items.map(function(_,i){return '<i'+(i===0?' class="is-on"':'')+'></i>';}).join('');
      gal.addEventListener('scroll',function(){var i=Math.round(gal.scrollLeft/(items[0].offsetWidth+8));$$('i',dots).forEach(function(d,j){d.classList.toggle('is-on',j===i);});},{passive:true});
    }
    update();
  }

  /* ------------------------------------------------------------ boot */
  /* ------------------------------------------------------------ pain map */
  function painMap(root){
    $$('[data-dot-for]',root).forEach(function(li){
      var dot=$('[data-dot="'+li.getAttribute('data-dot-for')+'"]',root);if(!dot)return;
      var on=function(){dot.classList.add('is-on');},off=function(){dot.classList.remove('is-on');};
      li.addEventListener('mouseenter',on);li.addEventListener('mouseleave',off);
      li.addEventListener('focusin',on);li.addEventListener('focusout',off);
    });
  }

  /* ------------------------------------------------------------ size guide */
  function sizeGuides(){
    var dlg=$('[data-size-dialog]');
    if(dlg&&dlg.showModal){
      $$('[data-size-open]').forEach(function(b){b.addEventListener('click',function(){dlg.showModal();lockScroll(true);});});
      $$('[data-size-close]',dlg).forEach(function(b){b.addEventListener('click',function(){dlg.close();});});
      dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close();});
      dlg.addEventListener('close',function(){lockScroll(false);});
    }else{
      // No <dialog> support: fall back to the accordion copy of the guide.
      $$('[data-size-open]').forEach(function(b){b.addEventListener('click',function(){var a=$('[aria-controls="gmx-sizes"]');if(a){if(a.getAttribute('aria-expanded')!=='true')a.click();a.scrollIntoView({behavior:'smooth',block:'center'});}});});
    }
    $$('[data-size-guide]').forEach(function(g){
      var input=$('[data-size-input]',g),out=$('[data-size-out]',g),rows=$$('[data-size-row]',g);
      if(!input)return;
      input.addEventListener('input',function(){
        var v=parseFloat(String(input.value).replace(',','.'));
        rows.forEach(function(r){r.classList.remove('is-match');});
        if(isNaN(v)){out.textContent='Entrez votre tour en cm, on vous donne la taille.';return;}
        var hit=null;
        rows.forEach(function(r){if(!hit&&v>=parseFloat(r.dataset.min)&&v<=parseFloat(r.dataset.max))hit=r;});
        // On a boundary value the larger size wins, as the copy advises.
        rows.forEach(function(r){if(v===parseFloat(r.dataset.min))hit=r;});
        if(!hit){
          var lo=parseFloat(rows[0].dataset.min);
          out.textContent=v<lo?'Mesure sous notre plus petite taille. Écrivez-nous, on vous conseille.':'Mesure au-dessus de notre plus grande taille. Écrivez-nous, on vous conseille.';
          return;
        }
        hit.classList.add('is-match');
        var size=hit.dataset.size;
        out.innerHTML='Votre taille : <b>'+esc(size)+'</b> <button type="button" class="gmx-link" data-size-pick>Choisir cette taille</button>';
        $('[data-size-pick]',out).addEventListener('click',function(){
          var radio=$$('input[data-option]').filter(function(i){return i.value===size;})[0];
          if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
          if(dlg&&dlg.open)dlg.close();
          toast('Taille '+size+' sélectionnée');
        });
      });
    });
  }

  function boot(){
    header();cart();accordions(document);magnetic();
    $$('[data-hero]').forEach(kneeMap);
    $$('[data-guide]').forEach(guide);
    $$('[data-pdp]').forEach(pdp);
    $$('[data-pmap]').forEach(painMap);
    sizeGuides();promo();eta();wrapAnim();
    smooth();
    intro(motion);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){accordions(e.target);$$('[data-hero]',e.target).forEach(kneeMap);$$('[data-guide]',e.target).forEach(guide);if(window.ScrollTrigger)window.ScrollTrigger.refresh();});
})();
